import { ability, defineRulesFor } from "@/plugins/ability";
import Api from '@/api/index';

const Users = {
  namespaced: true,
  state: {
    oneUser: null,
    user: null
  },
  mutations: {
    setCurrentUser(state, data) {
      if (state.user){
        state.user = {...data, ...state.user};
      } else {
        state.user = data
      }
      if (state.oneUser){
        state.oneUser = {...data, ...state.onUser};
      } else {
        state.oneUser = data
      }
    },
    // setOneUserEmployee(state, employee){
    //   state.oneUser = {
    //     ...state.oneUser,
    //     employee: {...employee}
    //   };
    // },
    login(state, user) {
      // automatizada na configuração de parse e fetch user - plugins/vue-auth
      state.user = user;
      ability.update(user.rules);
    },
    logout(state) {
      state.user = null;
      ability.update([]);
    }
  },

  actions: {
    // getCurrentEmployee(context, id){
    //   Api.Employee.current_employee(id).then(r=>r.data).then(r=>{
    //     Api.Employee.show(r.id).then(r => r.data).then(e=> {
    //       context.commit('setOneUserEmployee', e)
    //     }).catch(err => {
    //       console.log(err)
    //     })
    //   }).catch(err => {
    //     console.log(err)
    //   })
    // },
    setCurrentUser(context, data) {
      context.commit("setCurrentUser", data);
      // console.log('hey', data);
      // context.dispatch('getCurrentEmployee', data.id)
      // if (data) context.commit("setTokenData", localStorage.auth_token_default);
    }
  }
};

export default Users;
